import { atom } from "recoil";
import { ModalInterface } from "../utils/useModal";

export const ModalState = atom<ModalInterface[]>({
  key: "modalState",
  default: [],
});
